'use client';

import { TextLink } from '@petsmart-ui/sparky';
import { Fragment } from 'react';

import { dataLayerPush, getBaseUrlJoined, layoutEvents } from '@libs/analytics';
import { useDeviceType } from '@libs/common-next';

import type { Entry, Link, LinkAction } from '../../types';
import { getLinkFromLinkOrLinkAction, propsMapper } from '../../utils';
import { ComponentResolver } from '../../utils/ComponentResolver';
import type { LegacyNavAdoptionsProps } from './types';
import './LegacyNavAdoptions.scss';

export const trackingData = (data: object) => Object.assign(data, { ...layoutEvents.headerClick });

const TREATS_SIGN_HEAD_TEXT = 'Sign up, earn points, get treats';

export default function LegacyNavAdoptions({ livesSaved, secondaryNavigation }: LegacyNavAdoptionsProps) {
    const { navigationLinks, tabletNavigationLinks } = secondaryNavigation?.fields ?? {};
    const { isDesktop } = useDeviceType();
    const links = propsMapper<LinkAction | Link>(
        (isDesktop ? (navigationLinks as Entry[]) : (tabletNavigationLinks as Entry[])) ?? []
    );

    const flatLinks = links.map(linkOrLinkAction => getLinkFromLinkOrLinkAction(linkOrLinkAction));

    return (
        <>
            <div className="legacy-topnav__container">
                {flatLinks.map(({ actionText, sysId, webUrl }, index) => (
                    <Fragment key={sysId ?? webUrl ?? actionText}>
                        {index > 0 && <div className="legacy-topnav__divider">|</div>}
                        <TextLink
                            href={webUrl}
                            className="legacy-topnav__link"
                            onClick={() => {
                                dataLayerPush(
                                    trackingData({
                                        selection: actionText,
                                        link_url: getBaseUrlJoined(webUrl),
                                    })
                                );
                            }}
                        >
                            {actionText}
                        </TextLink>
                    </Fragment>
                ))}
            </div>
            <div className="legacy-topnav__container legacy-topnav__container--center">
                <ComponentResolver entry={livesSaved as LegacyNavAdoptionsProps['livesSaved']} />
            </div>
            <div className="legacy-topnav__container legacy-topnav__container--right">{TREATS_SIGN_HEAD_TEXT}</div>
        </>
    );
}
